import { useNavigate } from 'react-router-dom';
import { tagCloud } from '../../../mocks/site';

export default function TopicBand() {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden bg-secondary-700">
      <div className="absolute inset-0 opacity-[0.12]">
        <i className="ri-pages-line absolute -left-10 -top-6 text-[240px] text-background-50"></i>
        <i className="ri-scissors-line absolute -bottom-10 right-6 text-[200px] text-background-50"></i>
      </div>
      <div className="container-x relative z-10 py-14 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-medium tracking-widest text-accent-300">HOT TOPICS</p>
          <h2 className="mt-2 font-display text-2xl font-black text-background-50 md:text-4xl">
            此刻最热的考古话题
          </h2>
          <p className="mt-4 text-sm leading-7 text-background-50/80">
            从综艺考古到旧访谈，从口碑反转到当年真相，点开任意话题进入对应的旧瓜档案。
          </p>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          {tagCloud.map((t, i) => (
            <button
              key={t.name}
              onClick={() => navigate(`/column/dangnian-zhenxiang`)}
              className={`inline-flex cursor-pointer whitespace-nowrap items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-all hover:-translate-y-0.5 ${
                i % 4 === 0
                  ? 'bg-accent-500 text-background-50 hover:bg-accent-600'
                  : i % 4 === 1
                    ? 'bg-background-50/95 text-secondary-800 hover:bg-background-50'
                    : i % 4 === 2
                      ? 'border border-accent-400/60 bg-transparent text-accent-200 hover:bg-accent-500/20'
                      : 'border border-background-50/30 bg-transparent text-background-50/90 hover:bg-background-50/10'
              }`}
            >
              <i className="ri-price-tag-3-line text-sm"></i>{t.name}
              <span className="text-xs opacity-70">{t.count}</span>
            </button>
          ))}
        </div>

        <p className="mt-8 text-center text-xs text-background-50/60">
          没找到你关心的旧瓜？把关键词告诉我们，我们会把它送进下一批「考古重读」清单。
        </p>
      </div>
    </section>
  );
}